import type { Severity } from '../alerts/types.ts'
import { type LightningProtection, type LightningProtectionGroup, ProtectionPriority, ProtectionType } from './types.ts'

export const API_GATEWAY_TIMEOUT = 29_000
export const NO_USERS_NOTIFIED = 'NO_USERS_NOTIFIED'
export const ADD_USERLIST = 'add-user-list'

export const createTemporaryLightningProtectionVrn = (assetVrn: string, priority: number) =>
	`${assetVrn}-${ProtectionType.Lightning}-${priority}`

export const lightningPriorityToRingMap: Record<LightningProtection['priority'], keyof LightningProtectionGroup['rings']> = {
	[ProtectionPriority.LightningAlarm]: 'alarm',
	[ProtectionPriority.LightningWarning]: 'warning',
	[ProtectionPriority.LightningInfo]: 'info',
	[ProtectionPriority.LightningInfo2]: 'info2',
}

export const lightningRingToPriorityMap: Record<keyof LightningProtectionGroup['rings'], LightningProtection['priority']> = {
	alarm: ProtectionPriority.LightningAlarm,
	warning: ProtectionPriority.LightningWarning,
	info: ProtectionPriority.LightningInfo,
	info2: ProtectionPriority.LightningInfo2,
}

export const lightningRingToSeverityMap: Record<keyof LightningProtectionGroup['rings'], Severity> = {
	alarm: 'alarm',
	warning: 'warning',
	info: 'info',
	info2: 'info',
}

export const lightningPriorityToSeverityMap: Record<LightningProtection['priority'], Severity> = {
	1: 'alarm',
	2: 'warning',
	3: 'info',
	4: 'info',
}
export const userConfigurableAssetProtectionTypes: readonly ProtectionType[] = [
	'hail',
	'lightning',
	'weatherHazard',
	'wind',
	'precipitation',
]

// Precipitation's position here is a placeholder pending a product decision — see TODO.md Open Questions.
export const protectionTypePriorityOrder = ['lightning', 'weatherHazard', 'measurement', 'hail', 'wind', 'precipitation'] as const
